import { WaterBoilerAlertIcon } from './WaterBoilerAlertIcon';

/**
 * author: Michael Irigoyen
 * id EC21EC05-F45B-4560-A37E-3E721219A728
 * name water-boiler-alert
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-boiler-alert.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 */
export const WaterBoilerErrorIcon = WaterBoilerAlertIcon;
export default WaterBoilerErrorIcon